/*
Akhila 04/20/2023 2698964415 Added bew feature map data transformation
Akhila 04/24/2023 2698964415 bug fixed and prepoulated data
Akhila 06/08/2023 2698964415 created date change to date created field and column
Sohel 10/25/2023 2698964415 Fixed Created By Dropdown Page Break Issue
*/
import React, {createRef, useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
// import FileCopyIcon from "@material-ui/icons/FileCopy";
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';
import moment from 'moment';
export default function MapDataTransformTable1({
  searchData,
  submit,
  setSubmit,
  setRowSelected,
  mapDataTransform,
  exportManagerRecord,
  tempDataTranform = [],
  setTempDataTransform,
  tempUnCheckedRef,
  values,
}) {
  const columns = [
    // {
    //   title: "Seq Num",
    //   field: "seqNum",
    // },
    {
      title: 'Data Transformation Name',
      field: 'processorCode',
    },
    {
      title: 'Result Expression',
      field: 'resultExpr',
    },
    {
      title: 'Type',
      field: 'type',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="draft-status status">
            <span>Draft</span>
          </div>
        ) : (
          <div className="completed-status status">
            <span>Completed</span>
          </div>
        ),
    },
  ];
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const queryRef = useRef(null);
  const [rows, setRows] = useState(defaultRows);
  // based submit update table(2699761741)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  useEffect(() => {
    if (setTempDataTransform) {
      setTempDataTransform([]);
      tempUnCheckedRef.current = [];
    }
  }, []);
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (true) {
                  const arr = [...tempDataTranform].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    tableData: {...row.tableData, id: row?.dmProcessorId, checked: true},
                  });
                  setTempDataTransform(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempDataTranform]
                  .filter((ele) => ele?.processorCode !== row?.processorCode)
                  .map((ele) => {
                    return {
                      ...ele,
                      // tableData: { ...ele.tableData, checked: true },
                    };
                  });
                setTempDataTransform(updatedRows);
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-manager/processor/search/all`;
                // search triggers payload change(2699761741)
                const bodyObj = {
                  processorCode: searchData?.code ? searchData?.code : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: query?.search ? query?.search : '',
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  type: exportManagerRecord ? 'Export' : 'Import',
                };
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                queryRef.current = query;
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const obj = {};

                        for (let i = 0; i < values.preprocessors.length; i++) {
                          const key = `${values.preprocessors[i].processorCode}`;
                          if (!obj[key]) {
                            obj[key] = values.preprocessors[i];
                          }
                        }

                        const newData = data.map((el) => {
                          const key = `${el.processorCode}`;
                          if (obj[key]) {
                            // el.tableData.checked = true;
                            return {...el, tableData: {id: el?.processorCode, checked: true}};
                          } else {
                            return {...el, tableData: {id: el?.processorCode, checked: false}};
                          }
                        });
                        resolve({
                          data: newData.length > 0 ? newData : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbarButtonAlignment: 'left',
              search: false,
              pageSize: rows,
              toolbar: false,
              selection: true,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              emptyRowsWhenPaging: false,
              selectionProps: (rowData) => {
                let isDisabled = false;
                if (true) {
                  if (
                    tempDataTranform?.length > 0 &&
                    tempDataTranform[0].dmProcessorId !== rowData?.dmProcessorId
                  ) {
                    isDisabled = true;
                  } else if (tempDataTranform?.length === 0) {
                    isDisabled = false;
                  }
                  if (values?.preprocessors?.length > 0) {
                    const isSelected = values?.preprocessors?.filter(
                      (ele) => ele?.processorCode == rowData.processorCode,
                    );
                    if (isSelected.length > 0) {
                      isDisabled = true;
                    }
                  }
                }
                return {
                  disabled: isDisabled,
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            // actions={[
            //   // (rowData) => ({
            //   //   icon: () => <PlayCircleOutlineIcon />,
            //   //   tooltip: rowData?.isDraft !== "Y" ? "Run" : "",
            //   //   disabled:rowData?.isDraft === "Y",
            //   //   onClick: (event, rowData) => {
            //   //     setRunClicked(true);
            //   //     setRowDataCode(rowData?.code);
            //   //   },
            //   // }),
            //   {
            //     icon: () => <EditOutlinedIcon />,
            //     tooltip: "Edit",
            //     disabled: roleDataDisable?.edit === false,
            //     onClick: (event, rowData) => {
            //       dispatch(fetchEventTactic(rowData.id));
            //       setValue(1);
            //       setEventTacticCode(rowData.code);
            //       setRowSelected(rowData.id);
            //     },
            //   },
            //   (rowData) => ({
            //     icon: () => <FileCopyOutlinedIcon />,
            //     tooltip: "Copy",
            //     disabled: roleDataDisable?.add === false,
            //     onClick: (event, rowData) => {
            //       //setCopy(rowData.reportId);
            //       setCopyTrigger(true);
            //       setOldTriggerCode(rowData?.code);
            //       setCodeAndDescription(rowData);
            //     },
            //   }),
            //   {
            //     icon: () => (
            //       <>
            //         <Button
            //           type="button"
            //           variant="outlined"
            //           className={`search-btn`}
            //           disabled={roleDataDisable?.add === false}
            //           onClick={() => setValue(1)}
            //         >
            //           Add Trigger
            //         </Button>
            //       </>
            //     ),
            //     isFreeAction: true,
            //     disabled: roleDataDisable?.add === false,
            //     onClick: (event) => {
            //       setValue(1);
            //     },
            //   },
            //   // may require
            //   // (rowData) => ({
            //   //   icon: () => <GetAppIcon />,
            //   //   tooltip: "Download Report",
            //   // }),
            //   (rowData) => {
            //     return {
            //       icon: () => <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />,
            //       tooltip: "Delete",
            //       disabled: roleDataDisable?.delete === false,
            //       onClick: () => {
            //         handleDelete(rowData);
            //       },
            //     };
            //   },
            //   {
            //     icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //     tooltip: "Trigger Notes",
            //     onClick: (event, rowData) => {
            //       setIsNote(true);
            //       setTriggerData(rowData?.code);
            //     },
            //   },
            // ]}
            // may require
            // editable={{
            //   onRowDelete: (rowData) =>
            //     new Promise((resolve, reject) => {
            //       httpPaginationDelete(`rules/delete/rulegroup/${rowData.groupId}`).then(
            //         (response) => {
            //           if (response?.status === 200) {
            //             resolve();
            //             dispatch(fetchSuccess(response));
            //             setTimeout(() => {
            //               dispatch(resetMessage());
            //             }, 6000);
            //           } else {
            //             reject();
            //             dispatch(fetchError(response));
            //             setTimeout(() => {
            //               dispatch(resetMessage());
            //             }, 6000);
            //           }
            //         }
            //       );
            //     }),
            // }}

            // actions={[
            //   {
            //     icon: () => <SaveIcon />,
            //     tooltip: "Save User",
            //     onClick: (event, rowData) => console.log(rowData, "rowData"),
            //   },
            // ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block d-flex justify-content-end">
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              // Action: (props) => (
              //   <ActionMenuItem
              //     {...props}
              //     hiddenMenu={{
              //       edit: false,
              //       copy: false,
              //       notes: false,
              //       hiddenDelete: false,
              //       execution: true,
              //       run: true,
              //       usage: false,
              //       user: true,
              //       password: true,
              //       test: true,
              //     }}
              //     disableMenu={{
              //       disableEdit: roleDataDisable?.edit === false,
              //       disableRun: false,
              //       disableCopy: roleDataDisable?.add === false,
              //       disableDelete: roleDataDisable?.delete === false,
              //       disableUsage: false,
              //       disableExecution: false,
              //       disableNotes: false,
              //       disableUser: false,
              //       disablePassword: false,
              //       disableTest: false,
              //     }}
              //   />
              // ),
              // Toolbar: (props) => (
              //   <div>
              //     <MTableToolbar {...props} />
              //     <div>
              //       {
              //         <Button
              //           type="button"
              //           variant="outlisetOpenned"
              //           className={`mx-1 search-btn`}
              //           disabled={roleDataDisable?.add === false}
              //           isFreeAction={true}
              //           onClick={() => {}}
              //           startIcon={<AddIcon />}
              //         >
              //           Add Trigger
              //         </Button>
              //       }
              //     </div>
              //   </div>
              // ),
            }}
          />
        </div>
      </Grid>
      {/* {isLoading || loading || printUsageIsLoading ? <PageLoader /> : ""}
      {(errorMsg || deleteErrorMsg || copyErrorMsg || systemerrorMsg || printUsageErrorMsg) && (
        // <ErrorSnackbar
        //   errorMsg={
        //     errorMsg || deleteErrorMsg || copyErrorMsg || systemerrorMsg || printUsageErrorMsg
        //   }
        // />
      )} */}
      {/* {(successMsg ||
        tstmsg ||
        copySuccessMsg ||
        systemsuccessMsg ||
        downloadSuccessMsg ||
        printUsageSuccessMsg) && (
        <SuccessSnackbar
          successMsg={
            successMsg ||
            tstmsg ||
            copySuccessMsg ||
            systemsuccessMsg ||
            downloadSuccessMsg ||
            printUsageSuccessMsg
          }
        /> */}
      {/* )} */}
      {/* {customError && <WarningSnackbar errorMsg={`This Trigger is not being used anywhere`} />} */}
    </>
  );
}
